import React from 'react'
import styled from '@emotion/styled'

import SvgNotes from 'src/static/components/SvgNotes'

import {
  HeaderButtonContainer,
  HeaderButtonLabel,
  HeaderIconContainer,
} from './BaseButtons'

export const NotesButtonLabel = styled(HeaderButtonLabel)<{ active: boolean }>`
  color: ${({ active, theme }: { active: boolean; theme: any }) =>
    active ? theme.textColorActive : theme.textColor};
`

interface INotesButton extends React.HTMLProps<HTMLDivElement> {
  disabled: boolean
  active: boolean
  theme: any
  onClick: () => void
}

export default function NotesButton({
  disabled,
  active,
  theme,
  children,
  onClick,
}: INotesButton) {
  const label = 'Notes'
  return (
    <HeaderButtonContainer>
      <HeaderIconContainer disabled={disabled} onClick={!disabled ? onClick : undefined}>
        <SvgNotes fill={active ? theme.textColorActive : theme.textColor} />
        <NotesButtonLabel active={active}>{label}</NotesButtonLabel>
      </HeaderIconContainer>
      {children}
    </HeaderButtonContainer>
  )
}
